import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { useSiteContent } from "../admin/SiteContentContext";

export default function Hiring() {
  const { content } = useSiteContent();
  const { openRoles, siteInfo } = content;
  const [active, setActive] = React.useState(0);
  const role = openRoles[active] || openRoles[0];

  return (
    <main>
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="kicker">Now hiring</span>
            <h1 className="hero-heading text-white text-5xl md:text-6xl mt-5">Bring your care to work.</h1>
            <p className="text-slate-300 text-lg max-w-xl mt-6 leading-relaxed mb-8">
              We are building a team of dependable people who believe that everyday support can change the shape of a family's week.
            </p>
            <div className="flex flex-wrap gap-3">
              <a href="#roles" className="btn-lime">Apply to join us <ArrowRight className="w-4 h-4" /></a>
              <a href={`tel:${siteInfo.tollFree}`} className="btn-ghost"><Phone className="w-4 h-4" /> Ask about openings</a>
            </div>
          </div>
          <div className="relative rounded-3xl overflow-hidden border border-white/10">
            <img src="https://images.unsplash.com/photo-1702648156180-25d8be9c9527?w=1400&q=80" alt="team" className="w-full aspect-[4/3] object-cover" />
            <div className="absolute left-6 top-6 badge-pill">The 3E standard</div>
            <div className="absolute left-6 bottom-6 right-6">
              <p className="font-serif-display text-white text-2xl">Warmth is a skill.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="roles" className="py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center mb-12">
            <span className="kicker">Open roles</span>
            <h2 className="font-serif-display text-white text-4xl md:text-5xl mt-4">Find your place in the circle.</h2>
            <p className="text-slate-300 max-w-2xl mx-auto mt-5">Experience is valued. Character, reliability, and the willingness to notice the little things matter most.</p>
          </div>
          <div className="grid lg:grid-cols-3 gap-5">
            {openRoles.map((r, idx) => (
              <button key={r.title} onClick={() => setActive(idx)}
                className={`card-soft p-6 text-left transition ${idx === active ? "border-[#c7e34a]/50 ring-1 ring-[#c7e34a]/30" : "hover:border-white/20"}`}>
                <h3 className="font-serif-display text-white text-xl mb-2">{r.title}</h3>
                <p className="text-sm text-slate-400">{r.type}</p>
              </button>
            ))}
          </div>

          <div className="card-soft mt-8 p-8">
            <span className="kicker">Role spotlight</span>
            <h3 className="font-serif-display text-white text-3xl mt-3 mb-4">{role.title}</h3>
            <p className="text-slate-300 leading-relaxed max-w-3xl mb-6">{role.desc}</p>
            <div className="flex flex-wrap gap-2 mb-8">
              {role.tags.map(t => (
                <span key={t} className="text-xs px-3 py-1.5 rounded-full border border-white/10 text-slate-300 bg-white/5">{t}</span>
              ))}
            </div>
            <div className="card-soft p-6 border-l-2 border-l-[#c7e34a] mb-6">
              <p className="font-serif-display text-white text-lg leading-snug">“Would I want this person in my own family's home?”</p>
              <p className="text-sm text-slate-400 mt-2">That question guides how we welcome, train, and support our care professionals.</p>
            </div>
            <Link to="/booking" className="btn-lime">Start an application <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </section>
    </main>
  );
}
